<!--
 * @Author: 麦勇潮
 * @Date: 2021-01-14 16:34:19
 * @LastEditors: 麦勇潮
 * @LastEditTime: 2021-01-14 16:53:12
-->
<template>
  <div class="box" v-show="show">
    <div class="back" @click="close" v-if="href">关闭</div>
    <iframe :src="href" class="iframe" />
  </div>
</template>
<script>
export default {
  props: {
    href: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      show: false
    }
  },
  methods: {
    close() {
      this.$emit('close')
    }
  },
  mounted() {
    document.getElementsByClassName('iframe')[0].onload = () => {
      this.show = true
    }
  }
}
</script>
<style lang="scss" scoped>
.box {
  width: 80%;
  height: 80%;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -55%);
  z-index: 999999999999;

  .back {
    height: 30px;
    line-height: 30px;
    color: #000;
    background: #F7F7F7;
    padding: 10px;
    text-align: right;
  }
}

.iframe {
  border: none;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 40px;
  left: 0;
}
</style>
